/* eslint object-curly-newline: 0 */

import convert from 'convert-units';
import Workout from '../lib/workout/Workout';
import { sum } from '../lib/functions';

export default class WorkoutService {
  constructor(logger, store) {
    this.logger = logger;
    this.store = store;
  }

  // @param plannerComponents is the list of training planner components
  // making up a training plan
  // ignore the eslint warning about how this can be a static method
  // eslint-disable-next-line
  getEstimatedLoad(plannerComponents) {
    const calcs = plannerComponents.reduce((a, c) => {
      if (!c.estimatedDistance || !c.estimatedDuration) {
        return a;
      }
      return {
        distance: a.distance + c.inputType === 'distance' ? c.estimatedDistance : c.estimatedDuration / this.store.getters.velocity(c.zone),
        duration: a.duration + c.inputType === 'distance' ? c.estimatedDistance * this.store.getters.velocity(c.zone) : c.estimatedDuration,
        power: a.power + this.store.getters.averagePower(c.zone),
        count: a.count + ((c.estimatedDistance > 0 || c.estimatedDuration > 0) ? 1 : 0),
      };
    }, { distance: 0, duration: 0, power: 0, count: 0 });

    calcs.power /= calcs.count;
    const cp = this.store.getters.criticalPowerNow;
    return calcs.duration * (calcs.power / cp);
  }

  // @param plannerComponents is the list of training planner components
  // making up a training plan
  // ignore the eslint warning about how this can be a static method
  // eslint-disable-next-line
  getEstimatedDistance(plannerComponents) {
    return Workout.getEstimatedDistanceForTrainingPlanElements(plannerComponents);
  }

  // @param plannerComponents is the list of training planner components
  // making up a training plan
  // ignore the eslint warning about how this can be a static method
  // eslint-disable-next-line
  getEstimatedDuration(plannerComponents) {
    return Workout.getEstimatedDurationForTrainingPlanElements(plannerComponents);
  }

  getFirstTrainingPlanByMemberIdAndDate(memberId, momentDate) {
    const trainingPlans = this.store.getters.trainingPlansByMemberIdAndDate(memberId, momentDate);
    if (trainingPlans && trainingPlans.length > 0) {
      return trainingPlans[0];
    }
    return new Workout({
      localStartTime: momentDate,
    });
  }

  getTrainingPlansByMemberId(memberId) {
    return this.store.getters.trainingPlansByMemberId(memberId)
      .map(trainingPlan => new Workout(trainingPlan));
  }

  // @param trainingPlan is the training plan
  // @param activityTypeId is the activity type id
  // @param plannerComponents is the list of training planner components
  // making up a training plan
  // @param diaryMemberId is the memberId of the member this training plan is for
  // @param modifiedByMemberId is the memberId of the member modifying this training plan
  // @param removedByMemberId is the memberId of the member deleting this training plan. Setting
  // this to non-null means the plan will be deleted
  async saveTrainingPlan(
    trainingPlan,
    diaryMemberId,
    modifiedByMemberId,
    removedByMemberId = null,
  ) {
    // payload: {
    //   diaryDate: 'YYYYMMDD',
    //   plan: {
    //     activity_type_id: "2",
    //     comment: "no comment",
    //     diary_date: 'YYYYMMDD'
    //     daily_diary_id: null,
    //     removed_by: null,
    //     reps_count: 1,
    //     reps_duration: 60,
    //     reps_zone: 1,
    //     total_distance: 1,
    //     total_duration: 60,
    //     training_plan_id: null,
    //     plan_definition: [],
    //     load: int,
    //   }
    //   diaryMemberId: int,
    //   modifiedByMemberId: int,
    //   removedByMemberId: int,
    // }
    const diaryDate = trainingPlan.localStartTime.format('YYYYMMDD');

    const payload = {
      diaryDate,
      plan: {
        activity_type_id: trainingPlan.activityTypeId,
        comment: trainingPlan.comment,
        diary_date: diaryDate,
        daily_diary_id: trainingPlan.dailyDiaryId,
        reps_count: trainingPlan.repsCount,
        reps_duration: trainingPlan.repsDuration,
        reps_zone: trainingPlan.repsZone,
        total_distance: this.getEstimatedDistance(trainingPlan.planDefinition),
        total_duration: this.getEstimatedDuration(trainingPlan.planDefinition),
        training_plan_id: trainingPlan.trainingPlanId,
        plan_definition: trainingPlan.planDefinition,
        load: trainingPlan.getEstimatedLoad() || 0.0,
        title: trainingPlan.title,
      },
      diaryMemberId,
      modifiedByMemberId,
      removedByMemberId,
    };
    return this.store.dispatch('saveTrainingPlan', payload);
  }

  // Load the training plans into the store
  // @param memberId is the memberId to load training plans for
  // @param useCachedValues indicates whether or not we should use the current
  // store values if they exist
  async loadTrainingPlans(memberId, useCachedValues) {
    const payload = { memberId, useCachedValues };
    await this.store.dispatch('loadTrainingPlans', payload);
  }
}
